import { Injectable } from '@angular/core';

import { MaskPatterns } from 'src/app/constants/masks';

@Injectable()
export class MaskService {
	public phoneFormat(input: string): string {
		const maskedInput = input.replace(/\D/g, '').match(MaskPatterns.PHONE_MASK);
		input = !maskedInput[2]
			? maskedInput[1]
			: '(' + maskedInput[1] + ') ' + maskedInput[2] + (maskedInput[3]
				? '-' + maskedInput[3]
				: '');

		return input;
	}

	public phoneFormatInbound(input: string = ''): string {
		let mutable = input;

		if (mutable.length < 7)
			return mutable;

		if (mutable.length === 7) {
			mutable = mutable.replace(/[^0-9\-()\s]/g, '');
			mutable = mutable.substring(0, 3) + '-' + mutable.substring(3, 7);
		} else if (mutable.length === 10) {
			mutable = mutable.replace(/[^0-9\-()\s]/g, '');
			mutable = '(' + mutable.substring(0, 3) + ') ' + mutable.substring(3, 6) + '-' + mutable.substring(6, 10);
		}

		return mutable;
	}

	public socialFormat(input: string): string {
		const maskedInput = input.replace(/\D/g, '').match(MaskPatterns.FULL_SSN_MASK);
		input = !maskedInput[2]
			? maskedInput[1]
			: maskedInput[1] + '-' + maskedInput[2] + (maskedInput[3]
				? '-' + maskedInput[3]
				: '');

		return input;
	}

	public socialFormatInboundMask(input: string): string {
		let mutable = input.replace(MaskPatterns.REMOVE_SSN_MASK, '');

		if (mutable.length === 9) {
			mutable = mutable.replace(/[^0-9\-()\s]/g, '');
			mutable = 'XXX-XX-' + mutable.substring(5, 9);
			return mutable;
		}

		return input;
	}

	public last4Format(input: string): string {
		if (input.replace(MaskPatterns.REMOVE_SSN_MASK, '').length === 9 &&
			input.match(MaskPatterns.LAST_4_SSN_MASK)) {
			return input;
		}

		return this.socialFormat(input);
	}

	public last4FormatWithMask(input: string): string {
		if (input.replace(MaskPatterns.REMOVE_SSN_MASK, '').length === 9 &&
			input.match(MaskPatterns.LAST_4_SSN_MASK)) {
			return input;
		}

		return this.socialFormat(input);
	}

	public singleAlphaNumeric(input: string): string {
		let mutable = input.replace(MaskPatterns.SINGLE_ALPHANUMERIC, '');
		mutable = mutable.substring(0, 1);
		return mutable;
	}

	public singleNumeric(input: string): string {
		let mutable = input.replace(MaskPatterns.SINGLE_NUMERIC, '');
		mutable = mutable.substring(0, 1);
		return mutable;
	}

	public sixAlphaNumeric(input: string): string {
		let mutable = input.replace(MaskPatterns.SINGLE_ALPHANUMERIC, '');
		mutable = mutable.substring(0, 6);
		return mutable;
	}

	public sixNumeric(input: string): string {
		let mutable = input.replace(MaskPatterns.SIX_DIGIT, '');
		mutable = mutable.substring(0, 6);
		return mutable;
	}

	public systemNumberFormat(input: string): string {
		let mutable = input.replace(MaskPatterns.NON_DECIMAL_DIGITS, '');
		mutable = mutable.substring(0, 7);
		return mutable;
	}

	public weightFormat(input: string): string {
		const maskedInput = input.replace(/\D/g, '').match(MaskPatterns.WEIGHT_MASK);
		input = !maskedInput[1] ? maskedInput[0] : maskedInput[1];
		return input;
	}

	public zipCodeFormat(input: string): string {
		const maskedInput = input.replace(/\D/g, '').match(MaskPatterns.ZIPCODE_MASK);
		input = !maskedInput[2] ? maskedInput[1] : maskedInput[1] + '-' + maskedInput[2];
		return input;
	}

	public currencyFormat(input: string): string {
		let maskedInput = input.replace('$', '').match(MaskPatterns.CURRENCY);
		if (!maskedInput || !maskedInput[1])
			return '';

		return '$' + maskedInput[1];
	}

	public numericValues(input: string): string {
		let maskedInput = input.replace(/\D/g, '').match(MaskPatterns.NUMERIC_VALUES_ONLY);
		input = maskedInput[0];
		return input;
	}

	public dateFormat(input: string): string {
		let maskedInput = input.replace(/\D/g, '').match(MaskPatterns.DATE_MASK);

		if (!maskedInput[1])
			return '';

		let newFormat: string;
		let isValid: boolean = true;

		if (maskedInput[1]) {
			if (MaskPatterns.DATE_MONTH.test(maskedInput[1])) {
				if (maskedInput[1] !== '0' && maskedInput[1] !== '1') {
					newFormat = maskedInput[1].length == 2 ? maskedInput[1] : `0${maskedInput[1]}`;
				}
				else {
					newFormat = maskedInput[1];
				}
			} else {
				newFormat = maskedInput[1].slice(0, -1);
				isValid = false;
			}
		}

		if (maskedInput[2] && isValid) {
			newFormat += '/';
			if (MaskPatterns.DATE_DAY.test(maskedInput[2])) {
				if (maskedInput[2] !== '0' && maskedInput[2] !== '1' && maskedInput[2] !== '2' && maskedInput[2] !== '3') {
					newFormat += maskedInput[2].length == 2 ? maskedInput[2] : `0${maskedInput[2]}`;
				}
				else {
					newFormat += maskedInput[2];
				}
			} else {
				newFormat += maskedInput[2].slice(0, -1);
				isValid = false;
			}
		}

		if (maskedInput[3] && isValid) {
			newFormat += '/';
			if (maskedInput[3].length < 3 &&
				(maskedInput[3] === '1' || maskedInput[3] === '19' || maskedInput[3] === '2' || maskedInput[3] === '20')) {
				newFormat += maskedInput[3];
			} else if (MaskPatterns.DATE_YEAR.test(maskedInput[3])) {
				newFormat += maskedInput[3];
			} else {
				newFormat += maskedInput[3].slice(0, -1);
			}
		}

		return newFormat;
	}

	public shortDateFormat(input: string): string {
		let maskedInput = input.replace(/\D/g, '').match(MaskPatterns.DATE_SHORT_MASK);

		let newFormat: string;
		let isValid: boolean = true;

		if (maskedInput[1]) {
			if (MaskPatterns.DATE_MONTH.test(maskedInput[1])) {
				if (maskedInput[1] !== '0' && maskedInput[1] !== '1') {
					newFormat = maskedInput[1].length == 2 ? maskedInput[1] : `0${maskedInput[1]}`;
				}
				else {
					newFormat = maskedInput[1];
				}
			} else {
				newFormat = maskedInput[1].slice(0, -1);
				isValid = false;
			}
		}

		if (maskedInput[2] && isValid)
			newFormat += `/${maskedInput[2]}`;

		return newFormat;
	}

	public removePhoneMask(input: string): string {
		if (!isNaN(Number(input)))
			return input;

		return input.toString().replace(MaskPatterns.REMOVE_PHONE_MASK, '');
	}

	public removeSSNMask(input: string): string {
		if (!isNaN(Number(input)))
			return input;

		return input.toString().replace(MaskPatterns.REMOVE_SSN_MASK, '');
	}

	public removeZipCodeMask(input: string): string {
		if (!isNaN(Number(input)))
			return input;

		return input.toString().replace(MaskPatterns.REMOVE_ZIPCODE_MASK, '');
	}

	public removeCurrencyMask(input: string): any {
		if (!isNaN(Number(input)))
			return input;

		return input.toString().replace('$', '');
	}
}
